import styled from '@emotion/styled'
import { Divider, Layout } from 'antd'
import { LayoutRow, PageContent } from 'Layouts/styled'
import { PageProps } from './types'
import { clx } from 'Utils/clx'

const Main = styled(Layout)`
  background-color: inherit;
  background: transparent;
`

export type CustomPageProps = {
  header: React.ReactNode
  pageTitle?: React.ReactNode
  mainLayoutProps?: any
  ignoreHeaderDivider?: boolean
} & PageProps

const dividerStyle = { margin: 0 }
const Page: React.FC<CustomPageProps> = ({
  children,
  header,
  contentProps: { style: contentStyles, ...restContentProps } = {
    style: {},
  },
  mainLayoutProps = {},
  ignoreHeaderDivider = false,
}) => {
  return (
    <Main style={mainLayoutProps?.style}>
      <LayoutRow>
        {header}
        {ignoreHeaderDivider === true ? null : <Divider style={dividerStyle} />}
      </LayoutRow>
      <PageContent
        style={contentStyles}
        {...restContentProps}
        className={clx('skitWavesBackground')}
      >
        {children}
      </PageContent>
    </Main>
  )
}

export default Page
